<!-- https://www.figma.com/file/8qj3Smwuf9dQ4AIunIWX0f/Fondation-Beyeler-Kopie?node-id=548%3A5334 -->
<script>
    import BottomSheetLayout from "../components/BottomSheetLayout.svelte";

    import HeaderBar from "../../../components/header/HeaderBar.svelte";
    import FilterButton from "../components/FilterButton.svelte";
    import MoreButton from "../components/MoreButton.svelte";
    import MainFilterRow from "../components/MainFilterRow.svelte";
    import DefaultButton from "../../../components/DefaultButton.svelte";
    import EventListTile from "../components/EventListTile.svelte";
    import VideoListTile from "../components/VideoListTile.svelte";
    import StoreListTile from "../components/StoreListTile.svelte";
    import RecentListTile from "../components/RecentListTile.svelte";
    import { _ } from "svelte-i18n";
    import { getEntities, getEntity } from "../../../api-client";
    import { push } from "svelte-spa-router";
    import LoadingSquare from "../../../common/LoadingSquare.svelte";
    import { getEvents } from "../../../content/data/events";

    export let isContentLibrary = false;
    export let isExplore = false;

    $: slideOpen = false;
    $: desktopFilters = false;

    $: selectedFilters = [];

    $: events = [];
    $: storeItems = [];
    $: recents = [];
    $: videos = [];

    $: tags = getEntities("tag");

    $: allItems
        ? async () => {
              (await allItems)
                  .find({ type: "event" })
                  .forEach(async (event) => {
                      if (event.fk_livestream) {
                          event.livestream = await getEntity(
                              "livestream",
                              event.fk_livestream
                          );
                      }
                  });
          }
        : {};

    $: allItems = Promise.all([
        getEvents(),
        getEntities("store_item"),
        getEntities("recent"),
        getEntities("video"),
    ]).then(async ([events, storeItems, recents, videos]) => {
        events = events;
        storeItems = storeItems;
        recents = recents;
        videos = videos;

        let result = [];

        events.forEach(async (event) => {
            result.push({
                type: event.fk_livestream ? "livestream" : "event",
                ...event,
            });
        });

        storeItems.forEach((storeItem) => {
            result.push({
                type: "store_item",
                ...storeItem,
            });
        });

        recents.forEach((recent) => {
            result.push({
                type: "recent",
                ...recent,
            });
        });

        videos.forEach((video) => {
            result.push({
                type: "video",
                ...video,
            });
        });

        return result;
    });

    function toggleSlide() {
        slideOpen = !slideOpen;
    }

    function toggleDesktopFilters() {
        desktopFilters = !desktopFilters;
    }

    async function toggleFilter(event) {
        let filter = (await tags).find((filter) => filter.id == event.detail);

        if (selectedFilters.includes(filter)) {
            selectedFilters = selectedFilters.filter((f) => f !== filter);
        } else {
            selectedFilters = [...selectedFilters, filter];
        }
    }

    function checkFilter(item, selectedFilters) {
        if (selectedFilters.length == 0) {
            if (!isExplore && !isContentLibrary) {
                let isHighlight = item.isHighlight ?? false;
                return isHighlight;
            } else {
                return true;
            }
        }

        let itemTags = item.fk_tags ?? [];

        return selectedFilters.some((filter) => itemTags.includes(filter.id));
    }

    function filteredItems(items, selectedFilters) {
        if (isExplore) {
            return items.filter(
                (item) =>
                    checkFilter(item, selectedFilters) && item.type === "recent"
            );
        } else if (isContentLibrary) {
            return items.filter(
                (item) =>
                    checkFilter(item, selectedFilters) &&
                    (item.type === "livestream" || item.type === "video")
            );
        } else {
            return items.filter((item) => checkFilter(item, selectedFilters));
        }
    }
</script>

<div class="display-small">
    <HeaderBar title={$_("highlights_title")} />
</div>
<div style="height: 1px;" />

<BottomSheetLayout on:collapse={() => (slideOpen = false)} {slideOpen}>
    <!-- Header and main filters -->
    <div slot="firstSegment">
        <div class="display-big">
            <HeaderBar hideSeperator />
        </div>
        {#if isContentLibrary}
            <div class="headline-l">{$_("media_title")}</div>
        {:else if isExplore}
            <div class="headline-l">{$_("explore_tag_explore")}</div>
        {:else}
            <div class="headline-l">{$_("highlights_title")}</div>
        {/if}

        {#await Promise.all([tags, allItems]) then [tags, allItems]}
            <MainFilterRow
                filters={tags.filter((tag) =>
                    allItems.some((item) => item.fk_tags?.includes(tag.id))
                )}
                on:moreClicked={toggleSlide}
                on:toggleFilter={toggleFilter}
                {selectedFilters}
                showMore={slideOpen}
            />
        {:catch}
            <div class="error">
                <span class="text-l" style="font-size: 24px;">
                    {$_("entity_load_error")}
                </span>
            </div>
        {/await}
    </div>

    <!-- List Content -->
    <div slot="secondSegment" style="padding-left: 8px;">
        {#await allItems}
            <LoadingSquare />
        {:then items}
            {#each filteredItems(items, selectedFilters) as item, index}
                {#if item.type === "event"}
                    <div class="tile-wrapper">
                        <EventListTile
                            event={item}
                            on:click={() => push(`/event/${item.id}`)}
                        />
                    </div>
                {:else if item.type === "store_item"}
                    <div class="tile-wrapper">
                        <StoreListTile
                            {item}
                            on:click={() =>
                                item.link
                                    ? window.open(item.link, "_blank").focus()
                                    : null}
                        />
                    </div>
                {:else if item.type === "recent"}
                    <div class="tile-wrapper">
                        <RecentListTile
                            {item}
                            on:click={() =>
                                item.link
                                    ? window.open(item.link, "_blank").focus()
                                    : null}
                        />
                    </div>
                {:else if item.type === "video"}
                    <div class="tile-wrapper">
                        <VideoListTile
                            video={item}
                            on:click={() => push(`/video/${item.id}`)}
                        />
                    </div>
                {:else if item.type === "livestream"}
                    <div class="tile-wrapper">
                        <EventListTile
                            event={item}
                            on:click={() => push(`/event/${item.id}`)}
                        />
                    </div>
                {/if}
                {#if index < filteredItems(items, selectedFilters).length - 1}
                    <div class="divider-h highlight-divider" />
                {/if}
            {/each}
        {:catch}
            <div class="error">
                <span class="text-l" style="font-size: 24px;">
                    {$_("entity_load_error")}
                </span>
            </div>
        {/await}
    </div>

    <div slot="sliderContent" style="height: 100%;">
        <!-- Mobile Slider Content -->
        <div
            class="mobile-only mobile-slider-content"
            style={window.innerHeight}
        >
            <div
                class="headline-l"
                style="margin-bottom: 32px; margin-top: 8px;"
            >
                {$_("explore_tag")}
            </div>
            {#await Promise.all([tags, allItems]) then [tags, allItems]}
                <MainFilterRow
                    filters={tags.filter((tag) =>
                        allItems.some((item) => item.fk_tags?.includes(tag.id))
                    )}
                    {selectedFilters}
                    wrap
                    disableMoreButton
                    on:toggleFilter={toggleFilter}
                    showMore={slideOpen}
                />
            {:catch}
                <div class="error">
                    <span class="text-l" style="font-size: 24px;">
                        {$_("entity_load_error")}
                    </span>
                </div>
            {/await}

            <div class="text-m" style="margin: 32px 0 16px 0;">
                {$_("more_topics")}
            </div>

            <div class="desktop-other-filters">
                {#await Promise.all([tags, allItems])}
                    <LoadingSquare />
                {:then [tags, allItems]}
                    {#each tags.filter((e) => !e.isMainTag && allItems.some( (item) => item.fk_tags?.includes(e.id) )) as filter}
                        <FilterButton
                            {filter}
                            on:click={toggleFilter}
                            selected={selectedFilters.filter(
                                (e) => e === filter
                            ).length === 1}
                        />
                    {/each}
                {:catch}
                    <div class="error">
                        <span class="text-l" style="font-size: 24px;">
                            {$_("entity_load_error")}
                        </span>
                    </div>
                {/await}
            </div>

            {#if selectedFilters.length !== 0}
                <div class="floaty-button">
                    <DefaultButton
                        on:click={toggleSlide}
                        text={$_("show_contents")}
                    />
                </div>
            {/if}
        </div>

        <!-- Desktop Slider Content -->
        <div class="desktop-slider-content desktop-only">
            <MoreButton
                showsMore={desktopFilters}
                on:click={toggleDesktopFilters}
                class="desktop-only"
            />
            {#if desktopFilters}
                <div class="desktop-other-filters">
                    {#await Promise.all([tags, allItems])}
                        <LoadingSquare />
                    {:then [tags, allItems]}
                        {#each tags.filter((e) => !e.isMainTag && allItems.some( (item) => item.fk_tags?.includes(e.id) )) as filter}
                            <FilterButton
                                {filter}
                                on:click={toggleFilter}
                                selected={selectedFilters.filter(
                                    (e) => e === filter
                                ).length === 1}
                            />
                        {/each}
                    {:catch}
                        <div class="error">
                            <span class="text-l" style="font-size: 24px;">
                                {$_("entity_load_error")}
                            </span>
                        </div>
                    {/await}
                </div>
            {/if}
        </div>
    </div>
</BottomSheetLayout>

<style>
    .mobile-only {
        display: block;
    }

    .desktop-only {
        display: none;
    }

    .desktop-other-filters {
        padding: 8px 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .floaty-button {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 16px;
    }

    .mobile-slider-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .highlight-divider {
        margin: 16px 0;
    }

    @media (min-width: 1440px) {
        .mobile-only {
            display: none;
        }

        .desktop-slider-content {
            padding: 16px 0;
        }

        .desktop-only {
            display: block;
        }

        .tile-wrapper {
            cursor: pointer;
            margin-bottom: 32px;
            margin-top: 8px;
        }
    }
</style>
